module.exports = __webpack_public_path__ + "66801c7b97924e3357f7b3c05a3adfe9.jpg";